module.exports = __webpack_public_path__ + "img/20210123_163549.f5cac9c6.jpg";